<style lang="scss">
.zoezi-mobile-menu-inner {
    position: fixed;
    bottom: 56px;
    right: 0;
    z-index: 260;
    overflow-y: auto;
}
</style>

<template>
    <div :style="{'--animate-duration': animationDuration + 'ms'}">
        <transition
            appear
            enter-active-class="animate__animated animate__slideInRight"
            leave-active-class="animate__animated animate__slideOutRight"
        >
            <div
                v-if="$store.state.showMobileMenu"
                class="zoezi-mobile-menu-inner elevation-4"
                v-click-outside="{handler: onClickOutside}"
                style="max-height: calc(100vh - 112px)"
            >
                <v-sheet :color="$root.siteconfig.appbar.props.backgroundColor">
                    <v-list
                        nav
                        dense
                        style="background: inherit"
                    >
                        <v-list-item-group>
                            <component-wrapper
                                v-for="button in $root.siteconfig.buttons"
                                :key="button.id"
                                :config="button"
                                can-remove
                            />
                        </v-list-item-group>
                    </v-list>

                    <div class="px-4 pt-4 pb-2" v-if="$store.state.isLoggedIn && canCheckin && showCheckinButton">
                        <checkin-button :component="{ component: 'zoezi-button', props: { block:true, text: $translate('CHECKIN') } }" :checkinResources="checkinResources" @clicked="$store.state.showMobileMenu = false"/>
                    </div>
                    <div class="px-4 pb-2" v-if="canChangeDomain">
                        <v-btn color="primary" block class="zoezi-button-thin" @click="changeDomain">{{$translate('Change domain')}}</v-btn>
                    </div>
                    <div class="px-4 pb-2" v-if="canChangeToStaffPage">
                        <v-btn color="primary" block class="zoezi-button-thin" @click="changeToStaffPage">{{$translate('Staff page')}}</v-btn>
                    </div>
                </v-sheet>
            </div>
        </transition>
    </div>
</template>

<script>
import {isMobile, isExpoApp} from '../util.js'
import CheckinButton from './CheckinButton.vue'

export default {
    name: 'zoezi-mobile-menu',
    components: {
        CheckinButton
    },
    props: {
        showCheckinButton: {
            title: 'Show button to Check in',
            type: Boolean,
            default: true
        },
        checkinResources: {
            title: 'Resources to be displayed at check-in',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                getItems: () => {
                    return [];
                }
            },
            default: () => []
        },
        showStaffButton: {
            title: 'Show staff page button on mobile',
            type: Boolean,
            default: true
        }
    },

    methods: {
        onClickOutside() {
            this.$store.commit('setShowMobileMenu', false);
        },
        changeDomain() {
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'changeDomain' }));
            }
        },
        changeToStaffPage() {
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'changeToStaffPage' }));
            } else {
                window.location = '/staff#/dashboard';
            }
        },
        showCheckinDialog() {
            this.$store.commit('showCheckinDialog', {checkinResources: this.checkinResources});
        }
    },

    computed: {
        canCheckin() {
            return isMobile() || this.$api.hasPermission('Entry handling');
        },
        canChangeDomain() {
            return isExpoApp() && window.canChangeDomain;
        },
        canChangeToStaffPage() {
            return isMobile() && (isExpoApp() || this.showStaffButton) && this.$store.state.user?.isAdmin;
        },
        computedCheckinResources() {
            return this.checkinResources.map(resource => {
                return {
                    ...resource,
                    name: resource.name || resource.title
                }
            })
        }
    },

    data: () => ({
        animationDuration: 400
    }),
}
</script>
